import LocationStaffCard from "./LocationStaffCard";
export { default as LocationStaffIndicator } from "./LocationStaffIndicator";

export default LocationStaffCard;